export default {"src":"/_next/static/media/nextarrow.aef2f4a3.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};